// @module Tavanoteam.Calculator.Calculator
define('Calculator.Main.View'
	, [
		'Calculator.Selant.View'
		, 'Calculator.Coatings.View'
		, 'Calculator.SquareFoot.View'
		, 'Calculator.CubicFoot.View'


		, 'calculator_main.tpl'

		, 'Backbone'
		, 'jQuery'
	]
	, function (
		CalculatorSelantView
		, CalculatorCoatingsView
		, CalculatorSquareFootView
		, CalculatorCubicFootView

		, calculator_main_tpl

		, Backbone
		, jQuery
	) {
		'use strict';

		return Backbone.View.extend({

			template: calculator_main_tpl

			, initialize: function (options) {
				this.container = options.container;
				this.layoutComponent = this.container.getComponent('Layout');
				this.pdpComponent = this.container.getComponent('PDP');
			}

			, events: {
				'click [data-action="open-calc"]': 'openCalculator',
				'click [data-action="change-calculator"]': 'changeCalculator'
			}

			, openCalculator: function openCalculator() {
				if (this.isPDP) {
					var view = this.getCalculatorView();

					this.layoutComponent.showContent(view, { showInModal: true });
				}
			}

			, getCalculatorView: function getCalculatorView() {
				var calculatorType = this.pdpComponent.getItemInfo().item.custitem_ssc_web_calc_select;

				if (calculatorType == 'Sealant Calculator') {
					return new CalculatorSelantView({ container: this.container });
				} else if (calculatorType == 'Square Foot Calculator') {
					return new CalculatorSquareFootView({ container: this.container });
				} else if (calculatorType == 'Coatings Calculator') {
					return new CalculatorCoatingsView({ container: this.container });
				} else if (calculatorType == 'Cubic Foot Calculator') {
					return new CalculatorCubicFootView({ container: this.container });
				}
			}

			, changeCalculator: function changeCalculator(event) {
				$('.calculator-form-selected').removeClass('calculator-form-selected');
				$('.calculator-tab-button-selected').removeClass('calculator-tab-button-selected');
				$(event.currentTarget).addClass('calculator-tab-button-selected');

				var calculatorName = event.currentTarget.name;

				if (calculatorName == 'Sealant Calculator') {
					$('.calculator-form-sealant').addClass('calculator-form-selected');
				} else if (calculatorName == 'Coatings Calculator') {
					$('.calculator-form-coatings').addClass('calculator-form-selected');
				} else if (calculatorName == 'Square Foot Calculator') {
					$('.calculator-form-squarefoot').addClass('calculator-form-selected');
				} else if (calculatorName == 'Cubic Foot Calculator') {
					$('.calculator-form-cubicfoot').addClass('calculator-form-selected');
				}
				
			}

			, childViews: {
				'Calculator.Sealant': function () {
					return new CalculatorSelantView({ container: this.container });
				}
				, 'Calculator.Coatings': function () {
					return new CalculatorCoatingsView({ container: this.container });
				}
				, 'Calculator.SquareFoot': function () {
					return new CalculatorSquareFootView({ container: this.container });
				}
				, 'Calculator.CubicFoot': function () {
					return new CalculatorCubicFootView({ container: this.container });
				}
			}

			, getContext: function getContext() {

				this.isPDP = this.pdpComponent.getItemInfo();
				if (!!this.isPDP) {
					this.calculatorType = this.pdpComponent.getItemInfo().item.custitem_ssc_web_calc_select;
				}


				return {
					isPDP: !!this.isPDP,
					calculatorType: this.calculatorType || ''
				};
			}
		});
	});
